@reference "../../../v4/core/v4-style.css";

/**
 * DockableLayout styles
 * 
 * These styles use @apply to leverage Tailwind utilities
 * while keeping the layout outside of tailwind-root scope (for legacy page compatibility)
 */

.layoutRoot {
  @apply min-h-screen relative;
}

.panelContainer {
  @apply fixed z-50 left-0 bottom-0;

  &.noPointerEvents {
    @apply pointer-events-none;
  }
}

.panelContent {
  @apply h-full;

  &.enablePointerEvents {
    @apply pointer-events-auto;
  }
}

.resizeHandle {
  @apply absolute top-0 right-0 bottom-0 w-1 cursor-col-resize z-50;
  @apply hover:bg-bg-accent-emphasis/50 transition-colors;

  &.isResizing {
    @apply bg-bg-accent-emphasis;
  }

  // Expanded hit area
  &::after {
    content: "";
    @apply absolute inset-y-0 -right-1 w-3;
  }
}

.edgeDetector {
  @apply fixed left-0 bottom-0 z-40;
}

.mainContent {
  @apply min-h-screen bg-bg-default;

  // Use CSS variable for margin (animated by DockableLayout)
  margin-left: var(--sidebar-effective-width);
  // No transition needed - the variable itself animates!
}
